import { render, staticRenderFns } from "./SubscriptionDiscountAddModal.vue?vue&type=template&id=40e04b44"
import script from "./SubscriptionDiscountAddModal.vue?vue&type=script&lang=js"
export * from "./SubscriptionDiscountAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports